import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { HardHat, LogIn, UserPlus } from 'lucide-react';

export default function LoginPage() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (isRegister) await register(name, email, password);
      else await login(email, password);
      navigate('/');
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : Array.isArray(d) ? d.map(e => e.msg || '').join(' ') : 'Erro ao autenticar');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#F7F8FA' }}>
      <div className="hidden lg:flex lg:w-1/2 items-center justify-center relative" style={{ background: 'linear-gradient(135deg, #1E3A5F 0%, #0F2440 100%)' }}>
        <div className="text-center text-white p-12">
          <HardHat size={64} strokeWidth={1.5} className="mx-auto mb-6 opacity-90" />
          <h1 className="text-4xl font-bold mb-3" style={{ letterSpacing: '-0.02em' }}>PRUMO</h1>
          <p className="text-base opacity-70 max-w-md">Plataforma de gestao integrada para empresas de engenharia e construcao</p>
          <div className="flex gap-8 justify-center mt-10 opacity-50">
            <div className="text-center"><p className="text-2xl font-bold">100%</p><p className="text-xs">Digital</p></div>
            <div className="text-center"><p className="text-2xl font-bold">360</p><p className="text-xs">Gestao</p></div>
            <div className="text-center"><p className="text-2xl font-bold">AI</p><p className="text-xs">Orcamentos</p></div>
          </div>
          <p className="text-[10px] opacity-30 mt-8">Criado por: Rui Guimaraes</p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2.5 mb-8 lg:hidden">
            <div className="w-9 h-9 rounded-md flex items-center justify-center" style={{ background: '#1E3A5F' }}>
              <HardHat size={20} strokeWidth={2} color="#fff" />
            </div>
            <span className="text-lg font-bold" style={{ color: '#1E3A5F' }}>PRUMO</span>
          </div>
          <h2 className="text-xl font-bold mb-1">{isRegister ? 'Criar Conta' : 'Entrar'}</h2>
          <p className="text-sm mb-6" style={{ color: '#5A6474' }}>
            {isRegister ? 'Preencha os dados para criar a sua conta' : 'Aceda a sua conta para continuar'}
          </p>
          {error && <div data-testid="auth-error" className="p-3 mb-4 rounded-md text-sm font-medium" style={{ background: '#FDECEB', color: '#C4302B', border: '1px solid #F5C6CB' }}>{error}</div>}
          <form onSubmit={handleSubmit} className="space-y-4">
            {isRegister && (
              <div>
                <label className="field-label">Nome</label>
                <input data-testid="register-name-input" className="input" placeholder="Nome completo" value={name} onChange={e => setName(e.target.value)} required />
              </div>
            )}
            <div>
              <label className="field-label">Email</label>
              <input data-testid="login-email-input" type="email" className="input" placeholder="email@empresa.pt" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div>
              <label className="field-label">Password</label>
              <input data-testid="login-password-input" type="password" className="input" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button data-testid="login-submit-btn" type="submit" className="btn btn-primary w-full" disabled={loading}>
              {loading ? 'A processar...' : <>{isRegister ? <><UserPlus size={16} /> Registar</> : <><LogIn size={16} /> Entrar</>}</>}
            </button>
          </form>
          <button data-testid="toggle-auth-mode-btn" onClick={() => { setIsRegister(!isRegister); setError(''); }}
            className="mt-4 text-sm font-medium w-full text-center block cursor-pointer" style={{ background: 'none', border: 'none', color: '#5A6474' }}>
            {isRegister ? 'Ja tem conta? Entrar' : 'Criar nova conta'}
          </button>
        </div>
      </div>
    </div>
  );
}
